import { useEffect } from 'react';
import { attachComponentData } from '@backstage/core-plugin-api';
import {
  TECHDOCS_ADDONS_KEY,
  TECHDOCS_ADDONS_WRAPPER_KEY,
  TechDocsAddonLocations,
  useShadowRoot,
} from '@backstage/plugin-techdocs-react';

const STYLE_ID = 'entity-techdocs-background';

const EntityTechDocsBackgroundAddon = () => {
  const shadowRoot = useShadowRoot();

  useEffect(() => {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) {
      return undefined;
    }

    const pageBackground = window.getComputedStyle(
      document.body,
    ).backgroundColor;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      :host {
        --entity-techdocs-background: ${pageBackground};
      }

      body,
      .md-main,
      .md-container,
      .md-sidebar,
      .md-nav__title {
        background: var(--entity-techdocs-background);
      }

      .md-nav .md-nav__title {
        background-color: var(--entity-techdocs-background) !important;
        box-shadow: 0 0 0.4rem 0.4rem var(--entity-techdocs-background) !important;
      }
    `;
    shadowRoot.appendChild(style);

    return () => {
      style.remove();
    };
  }, [shadowRoot]);

  return null;
};

export const EntityTechDocsBackground = EntityTechDocsBackgroundAddon;

attachComponentData(
  EntityTechDocsBackground,
  TECHDOCS_ADDONS_WRAPPER_KEY,
  true,
);
attachComponentData(EntityTechDocsBackground, TECHDOCS_ADDONS_KEY, {
  name: 'EntityTechDocsBackground',
  location: TechDocsAddonLocations.Content,
});
attachComponentData(
  EntityTechDocsBackground,
  `${TECHDOCS_ADDONS_KEY}.entitytechdocsbackground`,
  true,
);
